// prettier-ignore
import * as React from 'react'

import { ChallengeView } from './Challenge.view'

export const Challenge = () => {
  return <ChallengeView />
}
